import React from "react";
import Heading from "./UI/Heading";
import FAQItems from "./FAQItems";

const FAQ = () => {
  const FAQ_CONTENT = [
    {
      id: "1",
      question: `Ipsum Lorem Placeholder Text?`,
      answer: `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Mollitia quisquam possimus cumque officiis iusto nihil aspernatur vero magnam, expedita atque
  eveniet sunt ea dolore repudiandae voluptatibus eaque ipsum delectus quis!`,
    },
    {
      id: "2",
      question: `Ipsum Lorem Placeholder Text?`,
      answer: `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Mollitia quisquam possimus cumque officiis iusto nihil aspernatur vero magnam, expedita atque
  eveniet sunt ea dolore repudiandae voluptatibus eaque ipsum delectus quis!`,
    },
    {
      id: "3",
      question: `Ipsum Lorem Placeholder Text?`,
      answer: `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Mollitia quisquam possimus cumque officiis iusto nihil aspernatur vero magnam, expedita atque
  eveniet sunt ea dolore repudiandae voluptatibus eaque ipsum delectus quis!`,
    },
    {
      id: "4",
      question: `Ipsum Lorem Placeholder Text?`,
      answer: `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Mollitia quisquam possimus cumque officiis iusto nihil aspernatur vero magnam, expedita atque
  eveniet sunt ea dolore repudiandae voluptatibus eaque ipsum delectus quis!`,
    },
    {
      id: "5",
      question: `Ipsum Lorem Placeholder Text?`,
      answer: `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Mollitia quisquam possimus cumque officiis iusto nihil aspernatur vero magnam, expedita atque
  eveniet sunt ea dolore repudiandae voluptatibus eaque ipsum delectus quis!`,
    },
    {
      id: "6",
      question: `Ipsum Lorem Placeholder Text?`,
      answer: `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Mollitia quisquam possimus cumque officiis iusto nihil aspernatur vero magnam, expedita atque
  eveniet sunt ea dolore repudiandae voluptatibus eaque ipsum delectus quis!`,
    },
  ];
  return (
    <section className="w-full px-10 md:w-4/5 2xl:w-[80rem] text-center mt-64 mx-auto">
      <Heading text="FaQ" />
      <div className="mt-20 flex flex-col gap-y-10">
        {FAQ_CONTENT.map((item) => {
          return <FAQItems key={item.id} question={item.question} answer={item.answer} />;
        })}
      </div>
    </section>
  );
};

export default FAQ;
